<!--
    Desarrollado por: Ing Wuilmer Garcia
    // Fecha:2021-05-12
    // Modificado por:
    // Fecha de ultima Modificacion:
    // Modificado por: 
    // Causa: 
-->

<template>
    <div>
        <!-- mensajes de confirmacion -->
        <mensajeSistema></mensajeSistema>

        <v-form ref="formDatos" lazy-validation>
            <v-card>                
            
                <v-card-text>
                    
                    <!-- Formulario control general  -->

                    <v-row class="pt-3">

                        <v-col cols="9" sm="9" md="9">
                            <v-row>

                                <v-col cols="12" sm="6" md="4" class="py-0">
                                    <v-text-field v-model="DatosEmpresa.nombre_empresa" ref="" label="Nombre" disabled dense  
                                        type="text" :rules="[validation.required, validation.max100]"
                                        prepend-icon="fa-school" required>
                                    </v-text-field>
                                </v-col>

                                <v-col cols="12"  sm="6" md="4" class="py-0">
                                    <v-radio-group v-model="Datos.vence_pass" ref="" label="Vence pass user" row dense>
                                        <v-radio :label="`Si`" :value="true" color="teal"></v-radio>
                                        <v-radio :label="`No`" :value="false" color="error"></v-radio>
                                    </v-radio-group>
                                </v-col>

                                <v-col cols="12" sm="6" md="4" class="py-0">
                                    <v-text-field  v-model="Datos.dia_vencimiento" ref="" label="Días de Vencimiento"  dense
                                        type="number" prepend-icon="fa-id-badge"
                                        :rules="[validation.required]">
                                    </v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="4" class="py-0">
                                    <v-select v-model="Datos.separador_decimal" ref="" label="Separación de Decimales"  dense
                                        :items="listSeparacionDecimal" item-value="id" item-text="descripcion"
                                        prepend-icon="fa-flag" :rules="[validation.selectReq]"> 
                                    </v-select>
                                </v-col>     


                                <v-col cols="12" sm="6" md="4" class="py-0">
                                    <v-select  v-model="Datos.id_almacen_default" label="Almacen default" ref=""  dense
                                        :items="listAlmacen" item-value="id" item-text="desc_almacen"
                                        prepend-icon="fa-flag" :rules="[validation.selectReq]"> 
                                    </v-select>
                                </v-col>

                                <v-col cols="12" sm="6" md="4" class="py-0">
                                    <v-select v-model="Datos.id_moneda" ref="" label="Moneda"  dense
                                        :items="listMoneda" item-value="id" item-text="desc_moneda"
                                        prepend-icon="fa-flag" :rules="[validation.selectReq]"> 
                                    </v-select>
                                </v-col>

                                                        
                                <v-col cols="12" sm="6" md="4" class="py-0">
                                    <v-select  v-model="Datos.id_pais" label="Pais default" ref=""  dense
                                        :items="listPais" item-value="id" item-text="nombre_pais"
                                        prepend-icon="fa-flag" :rules="[validation.selectReq]"> 
                                    </v-select>
                                </v-col>


                                <v-col cols="12" sm="6" md="4" class="py-0">
                                    <v-text-field v-model="Datos.num_ajuste_inventario" ref="" label="Num. Ajuste Inventario" dense 
                                        type="number" prepend-icon="fa-id-badge"
                                        :rules="[validation.required]">
                                    </v-text-field>
                                </v-col>                                    
                                
                                
                        
                            </v-row>
                        </v-col>

                        <v-col cols="12" sm="3" md="3" class="d-flex justify-center">
                            
                                <v-avatar size="116" hover @click='pickLogo'>
                                <v-icon v-if="!logoImg && !previewImgLogo"  class="fondo_add_img" dark size="80">fas fa-user</v-icon>
                                <img v-if="logoImg && !previewImgLogo" :src="logoImg" class="fondo_add_img" dark size="100">
                                <img v-if="previewImgLogo" :src="previewImgLogo" class="fondo_add_img" dark size="100">
                                <input type="file" style="display: none" ref="imageLogo" accept=".jpg, .png, .gif" @change="onFileLogo">
                            </v-avatar> 
                            
                        </v-col>

                           
                           
                    </v-row>

                    <!-- Fin control general -->

                </v-card-text>

                <v-divider></v-divider>


                <v-card-actions>
                    <v-spacer></v-spacer> 
                    <v-btn class="btn_style3" dark tile @click="$emit('close')">Cancelar</v-btn>
                    <v-btn class="btn_block_style2" dark tile @click="saveItem();">Guardar Cambios</v-btn>
                  

                </v-card-actions>

                    <span v-if="test">
                         
                    <!--
                    <code>Datos:  {{Datos}} </code> <br>
                    <code>Parametros: {{parametros}}</code>
                    -->
                </span>

            </v-card>

        </v-form>
    </div>

</template>



<script>
    import axios,  { API_URL } from '@/helpers/axios';
    import { validation } from "@/helpers/validator.js";
    import {mapMutations, mapGetters, mapActions} from 'vuex';
 
    export default {
        name:"ControlGeneral",
         
        props:{
            parametros:{
                type:Object
            },
            estadoComp:{
                type:Boolean
            },
        },

        mounted() {
            this.loadMain()
        },

        created(){
       //     this.actualizarParamentro()
        },


        data: () => ({
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            // paramComponente:{"id_modulo": 11,  'id_submodulo':100}, //sud_modulo y {},modulo
            session: sessionStorage, // variables de session del usuario
           ////////////////////////////////////////////////////////

            //// CONSULTA PRINCIPAL
            search: '',
            Datos: {},
            DatosEmpresa: {},
            rutaServer: API_URL,
            test:false,
         
            listAlmacen:[],
            listMoneda:[],
            listPais:[],
            listSeparacionDecimal:[{id:".", descripcion:"Punto (.)"},{id:",", descripcion:"Coma (,)"} ],

            //  imagen Logo empresa
            previewImgLogo: '',
            imageSaveLogo: '',
            
        }),


        //computadas
        computed: {
            ...mapGetters('login', [ 'componenteEvento']),

            validation() {
                return validation;
            },
      
            // Logo CLiente //    
            logoImg() {  

                if(this.DatosEmpresa.logo_ruta){
                    return (this.rutaServer+this.DatosEmpresa.logo_ruta+this.DatosEmpresa.logo_nombre)
                }else{
                    return null
                }
            },


        },

          
        watch: {             
             // cada vez que la estado, esta función será ejecutada
            estadoComp() {
                if(this.estadoComp){
                    this.loadMain()                    
                }else{   
                    //this.parametros = {}
                    this.limpiarForm()

                }
            }
        },

        methods: {
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations('mensajeSis', ['setEnviarMens']),
            ////////////////////////////////////////////////////////

            //  ------- Cargar todos los registros principales al iniciar el componente   --------
            async loadMain(){
                await this.limpiarForm() 
                await this.getQuery()                       
            
            },


             async getQuery(){
                try{                    

                    let response = await axios.get(`/sistema/configuracion/general/empresa/${this.session.id_empresa}`)
                    this.DatosEmpresa      = response.data.Empresa
                    this.listPais         = response.data.Pais
                    this.listAlmacen      = response.data.Almacen
                    this.listMoneda       = response.data.Moneda

                    if(response.data.GeneralConfig){
                        this.Datos          = response.data.GeneralConfig
                    }
                }
                catch(e){
                    if (e.response) {
                        let resp = e.response.data
                        console.log(resp)
                        this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                    }
                }
            },




            async limpiarForm(){

                this.$refs.formDatos.resetValidation()


                this.Datos = {
                                    id_usuario: this.session.id,
                                    id_empresa: this.session.id_empresa , id_pais:"", id_moneda:"", id_almacen_default:"",
                                    num_ajuste_inventario:0, vence_pass:"", dia_vencimiento:"",  separador_decimal:"",
                                             
                }
        
                this.previewImgLogo = null
               
            },

            
            //-----------  Guardar Registros -------------
            
            // Guarda CONTROL COMPRA
            async saveItem(){
                if (!this.$refs.formDatos.validate()) {
                    this.setEnviarMens({tipo:"W", mensaje: `Debe Ingresar todos los campos requeridos en el Formulario`, tiempo:null})
                    return 
                }

                if (!this.session.id_sucursal) {
                    this.setEnviarMens({tipo:"W", mensaje: `Error en selecionar sucursal`, tiempo:null})
                    return 
                }
                this.Datos.id_sucursal = this.session.id_sucursal

                try{    
                    let params = {general:this.Datos, empresa: this.DatosEmpresa}
                    let res = await axios.put(`/sistema/configuracion/general/empresa/${this.session.id_empresa}`,params)
                    // this.$emit('close')
                    this.setEnviarMens({tipo:`${res.data.messageT}`, mensaje: `${res.data.message}`, tiempo:6000})

                    if((this.previewImgLogo) && (this.imageSaveLogo)){
                        this.saveLogo()
                    }                    
                } 
                catch(e){
                    if (e.response) {
                        let resp = e.response.data
                        console.log(resp)
                        this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                    }
                }            

            },


            // guardar imagen
            async saveLogo(){ 

                try {

                    let formData = new FormData();
                    formData.append('subirArchivo', this.imageSaveLogo)
                    formData.append('id_us_ing', this.session.id)
                    formData.append('id_empresa', this.Datos.id)
                    formData.append('archivo_old', this.Datos.logo_nombre)
                    let resp = await axios.post( 'archivo/sistema/logo',
                        formData,
                        {
                            headers: {'Content-Type': 'multipart/form-data' }
                        })

                        console.log(resp)
                        this.limpiarForm()

                } catch (error) {
                    console.log(error);
                    this.setEnviarMens({tipo:"E", mensaje: `Error en Subir Imagen`, tiempo:null})                    
                }
               
            },
             ///    SUBIR LOGO CLIENTe     ///
            /////////////////////////////////////////
            
            // contenedor del logo empresa
            pickLogo () {
                // activar imput tipo file 
                this.$refs.imageLogo.click ()
            },


            // Seleccion del archivo por el usuario
            onFileLogo (e) {
                const files = e.target.files || e.dataTransfer.files;

                if (!files.length) return;
                // crea imagen temporar para visualizar
                this.createImageLogo(files[0]);

                if(files[0] !== undefined) {
                      this.imageSaveLogo = files[0] // this is an image file that can be sent to server...
                }
            },

            // funcion para crear una imagen temporal
            createImageLogo(file) {

                var reader = new FileReader();
            
                reader.onload = e => { 
                    this.previewImgLogo = e.target.result;
                };
                reader.readAsDataURL(file);
            },


            

        },
    }
</script>


<style scoped>

    .fondo_add_img{
        padding-left: 0;
        padding-right: 0;
        margin-left: 0;
        margin-right: 0;
        cursor:pointer; cursor: hand;
        border: 4px solid #FFF;
        border-color: #474545;
        color: #524f4f;
    }

</style>